// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dumbell_Chart_wrapper__D7dxn {
  width: 100%;
  padding: 1.5rem;
}

.Dumbell_Chart_subtitle__cBRPS {
  font-size: 0.8125rem;
  margin: 0 0 0.25rem;
}

.Dumbell_Chart_title__9OVz- {
  margin: 0 0 1rem;
  font-size: 1.125rem;
}

.Dumbell_Chart_labels__Ea\\+Ml {
  padding: 0 0.625rem;
  margin-top: 0.25rem;
}

.Dumbell_Chart_labelGroup__N0bQD {
  text-align: center;
}

.Dumbell_Chart_labelKey__BPxDx {
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.05em;
}

.Dumbell_Chart_labelValue__l4hug {
  font-size: 1.375rem;
  font-weight: 700;
  color: #1e293b;
}

.Dumbell_Chart_delta__HY8Om {
  font-size: 0.8125rem;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Summary/Project_Page/Dumbell_Chart.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB","sourcesContent":[".wrapper {\n  width: 100%;\n  padding: 1.5rem;\n}\n\n.subtitle {\n  font-size: 0.8125rem;\n  margin: 0 0 0.25rem;\n}\n\n.title {\n  margin: 0 0 1rem;\n  font-size: 1.125rem;\n}\n\n.labels {\n  padding: 0 0.625rem;\n  margin-top: 0.25rem;\n}\n\n.labelGroup {\n  text-align: center;\n}\n\n.labelKey {\n  font-size: 0.6875rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n}\n\n.labelValue {\n  font-size: 1.375rem;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.delta {\n  font-size: 0.8125rem;\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Dumbell_Chart_wrapper__D7dxn`,
	"subtitle": `Dumbell_Chart_subtitle__cBRPS`,
	"title": `Dumbell_Chart_title__9OVz-`,
	"labels": `Dumbell_Chart_labels__Ea+Ml`,
	"labelGroup": `Dumbell_Chart_labelGroup__N0bQD`,
	"labelKey": `Dumbell_Chart_labelKey__BPxDx`,
	"labelValue": `Dumbell_Chart_labelValue__l4hug`,
	"delta": `Dumbell_Chart_delta__HY8Om`
};
export default ___CSS_LOADER_EXPORT___;
